<template>
  <div>
<!--    <loading></loading>-->
<!--    <page-header></page-header>-->
<!--    <helmet></helmet>-->
<!--    <div class="page-wrap" id="fullpage">-->
<!--      <canvas class="bg-particles" id="bg-particles"></canvas>-->
<!--      <welcome></welcome>-->
<!--      <about></about>-->
<!--      <apps></apps>-->
<!--      <contact></contact>-->
<!--    </div>-->
<!--    <page-footer></page-footer>-->
  </div>
</template>

//
<script>
// import loading from "@/components/loading/loading.vue";
// import helmet from "@/components/helmet/helmet.vue";
// import about from "@/components/about/about.vue";
// import welcome from "@/components/welcome/welcome.vue";
// import apps from "@/components/apps/apps.vue";
// import contact from "@/components/contactUs/contact.vue";
// import pageHeader from "@/components/pageHeader/pageHeader.vue";
// import pageFooter from "@/components/pageFooter/pageFooter.vue";
export default {
  name: "Home",
  components: {
    // loading,
    // helmet,
    // pageHeader,
    // about,
    // apps,
    // contact,
    // welcome,
    // pageFooter
  }
};
</script>

<style scoped>

</style>
